import {
  ROOT,
  ALL_LOGS,
  LOG_OTA,
  LOG_INVENTORY,
  LOG_ERROR,
  LOG_DETAIL,
  LOG_EXPAND
} from "@/_helpers/constant.js";
import { requestOptions, handleResponse } from "@/_helpers";

function getAllLogs(data) {
  return fetch(ROOT + ALL_LOGS, requestOptions.post(data))
    .then(handleResponse)
    .then(data => {
      return data;
    });
}

function getLogOta(data) {
  return fetch(ROOT + LOG_OTA, requestOptions.post(data))
    .then(handleResponse)
    .then(data => {
      return data;
    });
}
function getLogInventory(data) {
  return fetch(ROOT + LOG_INVENTORY, requestOptions.post(data))
    .then(handleResponse)
    .then(data => {
      return data;
    });
}
function getLogError(data) {
  return fetch(ROOT + LOG_ERROR, requestOptions.post(data))
    .then(handleResponse)
    .then(data => {
      return data;
    });
}
function getDetailLog(data) {
  return fetch(ROOT + LOG_DETAIL + `?id=${data.id}&processTrackingId=${data.processTrackingId}`, requestOptions.get())
    .then(handleResponse)
    .then(data => {
      return data;
    });
}

function getExpandLog(data) {
  return fetch(ROOT + LOG_EXPAND, requestOptions.post(data))
    .then(handleResponse)
    .then(data => {
      return data;
    });
}

//#endregion
export const log = {
  getAllLogs,
  getLogOta,
  getLogInventory,
  getLogError,
  getDetailLog,
  getExpandLog
}